import React from "react";
import GUI from "../GUI";

export type TTHProps = React.ComponentPropsWithoutRef<"th">
export type TTableLabel = Record<string,string>|((col:string) => string|JSX.Element)
export type TTHPropper = TTHProps|( (col:string) => TTHProps )
export type TTableHeadProps = {
    disableSort?:boolean
    sort:string
    cols:string[]
    label?:TTableLabel
    htr?:React.ComponentPropsWithoutRef<"tr">
    th?:TTHPropper
    onSort:(col:string) => void
}

export default function TableHead(props:TTableHeadProps){
    const dir = props.sort[0]=="-" ? -1 : 1
    const sort = dir<0 ? props.sort.slice(1) : props.sort
    const headers = props.cols.map(col => {
        const thProps = GUI.getProps(props.th, col)
        const {className,onClick,...th} = thProps
        const _onClick = (e:React.MouseEvent<HTMLTableCellElement>) => {
            onClick?.(e)
            if (props.disableSort) return
            props.onSort( sort==col ? (dir<0 ? col : `-${col}`) : col )
        }
        var cell:string|JSX.Element
        if (props.label instanceof Function) cell = props.label(col)
        else if (props.label) cell = props.label[col] || col
        else cell = col

        const arrow = props.disableSort ? <></> : <div className="arrow"/>
        return <th key={col} {...th} className={GUI.joinClass(className, sort==col ? ("sort " + (dir<0 ? "dec" : "asc")) : "", )} onClick={_onClick}>
            <div className="th">{cell}{arrow}</div>
        </th>
    })

    return <thead>
        <tr {...props.htr}>
            {headers}
        </tr>
    </thead>
}